import React from 'react'
import { Element } from '../../styled';
import { CardItem } from '../../../../../../components/Card';
// import Switch from '../../../../../../components/inputs/Switch';
// import { useFetch } from '../../../../../../hooks';


const NotificationUser = ({ user: { name, phone, /*notification, report */ } }) => {

    // const { doFetch } = useFetch({
    //     url: `/rpc/setalertsettings`,
    //     method: 'POST'
    // })

    // const [isNotifications, setNotifications] = useState(notification.value)
    // const [isReports, setReports] = useState(report.value)

    // const handleSwitchNotifications = () => {
    //     doFetch({
    //         data: {
    //             setname: notification.key
    //         }
    //     }).then(res => {
    //         if (res === 1) {
    //             setNotifications(prev => !prev)
    //         }
    //     }).catch(err => {
    //         console.log(err)
    //     });
    // }

    // const handleSwitchReports = () => {
    //     doFetch({
    //         data: {
    //             setname: report.key
    //         }
    //     }).then(res => {
    //         if (res === 1) {
    //             setReports(prev => !prev)
    //         }
    //     }).catch(err => {
    //         console.log(err)
    //     });

    // }

    return (
        <Element>
            <CardItem
                left={{
                    name: name,
                    value: phone
                }}
            />
            {/* <CardItem
                left={{
                    name: notification.label
                }}
                right={<Switch active={isNotifications} onClick={handleSwitchNotifications} />}
            />
            <CardItem
                left={{
                    name: report.label
                }}
                right={<Switch active={isReports} onClick={handleSwitchReports} />}
            /> */}
        </Element>
    )
}

export default NotificationUser
